export default __webpack_public_path__ + "static/media/gold-bg-mobile.c48c7cd4.svg";